import { useEffect, useState } from 'react';
import { useEnums } from './atoms';

// Fetches the backend-owned gatekeeper enums once (cached in a shared jotai atom), for feeding
// Carbon Dropdowns — the FE never hardcodes a parallel option list.
export function usePricingEnums() {
  const { enums, load } = useEnums();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    load().catch((e: Error) => active && setError(e.message));
    return () => {
      active = false;
    };
  }, [load]);

  return { enums, isLoading: !enums && !error, error };
}
